import {
    $, addAction, doAction, removeAction,
} from '@situation/setdesign.util';

const CONSENT = '#onetrust-consent-sdk';
const CONSENT_UI = '#onetrust-banner-sdk, #onetrust-pc-sdk';
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
const modalOpen = () => $('.modal--open').length > 0;
const focusInModal = () => $(document.activeElement).closest('.modal--open').length > 0;

// set-design's focus trap captures the modal's first/last focusable elements once, on open.
// Re-running its activation recaptures them and moves focus to the modal container.;
const reactivateTrap = () => {
    removeAction('key.tab', window.FocusState.prototype.trapFocus);
    doAction('focusStateActivate');
};

const consentUiOpen = () => $(CONSENT_UI)
    .toArray()
    .some((el) => $(el).is(':visible') && window.getComputedStyle(el).visibility !== 'hidden');
// Gravity Forms' AJAX validation re-renders the form and replaces the trap's nodes, which leaves
// Tab stuck on the close button.;
$(document).on('gform_post_render', () => {
    if (!modalOpen() || !window.FocusState) {
        return;
    }

    const { activeElement } = document;
    reactivateTrap();

    // activate() focuses the modal container; hand focus back to whatever GF focused.
    if (activeElement && document.contains(activeElement)) {
        activeElement.focus();
    }
});

// The CookiePro banner and a modal opened from the URL (/#newsletter) can both want focus on load.
// The banner goes first: if it's up when the modal activates (50ms after showModal), give focus back.
addAction('showModal', () => {
    setTimeout(() => {
        if (consentUiOpen()) {
            $(CONSENT_UI).filter(':visible').find(FOCUSABLE).filter(':visible')
                .first()
                .trigger('focus');
        }
    }, 100);
});

// The trap only wraps Tab at the modal's own first/last elements, so focus that starts in the banner
// walks out into the page behind. Keep it in the modal or the banner.
$(document).on('focusin', (event) => {
    if (!modalOpen() || !window.FocusState || $(event.target).closest(`.modal--open, ${CONSENT}`).length) {
        return;
    }

    reactivateTrap();
});

// Once the banner is dismissed OneTrust drops focus on <body> (no focusin), so move it into the
// modal. Wait for the consent UI to actually close; "Customize settings" swaps in the preference center.
const handOffWhenConsentCloses = () => {
    const check = (triesLeft) => {
        if (!modalOpen() || !window.FocusState || focusInModal()) {
            return;
        }
        if (!consentUiOpen()) {
            reactivateTrap();
        } else if (triesLeft > 0) {
            setTimeout(check, 100, triesLeft - 1);
        }
    };

    setTimeout(check, 100, 20);
};

$(document).on('click', `${CONSENT} button`, handOffWhenConsentCloses);
window.addEventListener('OneTrustGroupsUpdated', handOffWhenConsentCloses);
